import lodash from 'lodash';

import {EASINGS} from '../../ecs/easingHelper';
import letterFadeUnrollInTopGif from '../../../assets/images/transitions/letterFadeUnrollInTop.gif';

/**
 * The name that signals this preset.
 * @const {string}
 */
export const PRESET_LETTER_FADE_UNROLL_OUT_TOP = 'letterFadeUnrollOutTop';

/**
 * The preset details.
 *
 * @type {{
 *   name: string,
 *   flow: string,
 *   details: Object.<string, {
 *     easing: string,
 *     parse: boolean,
 *     values: *|Array.<*>,
 *     time: {start: (string|number), end: (string|number)}
 *   }>,
 *   template: {}
 * }}
 */
export const letterFadeUnrollOutTopPresetDetails = {
  // The name of the preset.
  name: PRESET_LETTER_FADE_UNROLL_OUT_TOP,

  // A human friendly name for the preset.
  humanName: 'Letter - Fade & Unroll Out From Top',

  // A preview of the transition.
  gif: letterFadeUnrollInTopGif,

  // The element names that this preset can be used for or true for all elements.
  elements: ['text'],

  // The preset direction: in, out, middle. This is used in the UI logic.
  flow: 'out',

  // Each property that will change during the transition.
  details: {
    'letter.rotate': {
      time: {
        end: 'end.-1000',
        start: 'end.-1800'
      },
      easing: EASINGS.easeInExpo,
      values: [
        0,
        -30
      ],
      immediateRender: false,
      stagger: -30
    },
    'letter.opacity': {
      time: {
        end: 'end.-1000',
        start: 'end.-1800'
      },
      easing: EASINGS.easeInExpo,
      values: [
        1,
        0
      ],
      stagger: -30,
      immediateRender: false,
      staggerDuration: false
    },
    'letter.translateY': {
      time: {
        end: 'end.-1000',
        start: 'end.-1800'
      },
      easing: EASINGS.easeInExpo,
      values: [
        0,
        -200
      ],
      immediateRender: false,
      stagger: -30
    },
  },

  // How this preset can be used in the source (including optional parameters).
  // This will be turned into a JSON string, so no functions can be used.
  template: {
    preset: PRESET_LETTER_FADE_UNROLL_OUT_TOP,
    options: {},
  },
};

letterFadeUnrollOutTopPresetDetails.template.options = lodash.cloneDeep(letterFadeUnrollOutTopPresetDetails.details);

// This defines the key in the presets object.
export const presetName = PRESET_LETTER_FADE_UNROLL_OUT_TOP;

// This defines the value of the presets object.
export default letterFadeUnrollOutTopPresetDetails;
